import { withTheme } from '@emotion/react';
import React, { useState, useEffect } from 'react';
import { components } from 'react-select';
import Async from 'react-select/async';

const { ValueContainer, Placeholder } = components;

function buildOptions(data) {
  return data.map(pc => {return { value: pc.p, label: pc.p}})
}

function AsyncInput(props) {
  const { countryCode } = props;
  const [postalCodes, setPostalCodes] = useState({});
  const [initialOptions, setInitialOptions] = useState({});

  useEffect(() => {
    // Load postal codes dynamically based on the country code
    import(
      `../../localization/postalCodes/${countryCode}.json`
    ).then(module => {
      setInitialOptions(buildOptions(module.default).slice(0, 10));
      setPostalCodes(buildOptions(module.default));
    });
  }, [countryCode]);

  const CustomValueContainer = ({ children, ...props }) => {
    return (
      <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.selectProps.menuIsOpen}>
          {props.selectProps.placeholder}
        </Placeholder>
        {React.Children.map(children, child =>
          child && child.type !== Placeholder ? child : null
        )}
      </ValueContainer>
    );
  };

  const CustomClearText = () => 'X';
  const ClearIndicator = props => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles('clearIndicator', props)}
      >
        <div style={
          {  
            cursor: 'pointer',
            borderRadius: '20px',
            border: '2px solid',
            padding: '3px 5px',
            fontWeight: 'bold',
            fontSize: '12px',
            color: '#828282',
            borderColor: '#828282',
            fontFamily: '"Proxima Nova", Helvetica, sans-serif'
          }
        }>{children}</div>
      </div>
    );
  };

  // React select custom styles
  const customStyles = {
    dropdownIndicator: provided => ({
      ...provided,
      display: 'none'
    }),
    menu: (provided, state) => ({
      ...provided,
      borderRadius: '0 0 6px 6px',
      color: props.theme.colors.neutral1,
      margin: 0,
      padding: 0,
      backgroundColor: props.theme.colors.neutral2,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: '54px'
    }),
    menuList: provided => ({
      ...provided,
      fontFamily: props.theme.fonts.secondary,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: '280px'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? props.theme.colors.neutral2 : props.theme.colors.contrast2,
      color: props.theme.colors.neutral1,
      padding: 20,
      "&:hover": {
        backgroundColor: props.theme.colors.neutral2,
      },
    }),
    input: (provided, state)  => ({
      ...provided,
      fontFamily: props.theme.fonts.secondary,
      fontSize: '16px',
      height: '18px',
      marginTop: '2px'
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: props.theme.colors.neutral2,
      border: state.isFocused ? 'none' : 'none',
      borderBottom: state.isFocused ? `3px solid ${props.theme.colors.primary1}` : state.hasValue ? `3px solid ${props.theme.colors.primary4}` : `3px solid ${props.theme.colors.primary4}`,
      borderRadius: '6px 6px 0 0',
      boxShadow: 'none',
      width: '100%',
      height: '54px',
      "&:hover": {
        borderColor: props.theme.colors.primary1
      },
    }),
    indicatorSeparator: () => {},
    IndicatorsContainer: (provided, state) => ({
      ...provided,
      borderRadius: '20px',
      border: '3px solid',
      padding: '0',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      top: '26px',
      marginTop: '4px',
      "&:hover": {
        backgroundColor: props.theme.colors.primary1
      },
    }),
    container: provided => ({
      ...provided,
      width: '100%',
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: state.isFocused || state.hasValue ? props.theme.colors.primary1 : props.theme.colors.neutral3,
      position: 'absolute',
      top: state.isFocused || state.hasValue ? '12px' : '26px',
      fontSize: state.hasValue || state.isFocused ? '11px' : '16px',
      "&:hover": {
        
      },
    }),
  }

  return (
    <Async
      components={{ValueContainer: CustomValueContainer, ClearIndicator}}
      styles={customStyles}
      placeholder={props.countryCode !== "us" ? "Postal Code" : "Zip Code"}
      loadOptions={(inputValue, callback) => {
        callback(postalCodes.filter(x => x.value.toLowerCase().startsWith(inputValue.toLowerCase())).slice(0, 25))
      }}
      value={props.value}
      defaultOptions={initialOptions}
      defaultValue={props.zipcodeOption || null}
      onChange={e => props.onChange(e)}
      isClearable={true}
    />
  )
}

export default withTheme(AsyncInput);